import axios from 'axios';

const proto   = window.location.protocol === 'https:' ? 'https' : 'http';
const isDev   = window.location.port === '3000'; // CRA dev server
const ORIGIN  = process.env.REACT_APP_API_URL ||
  (isDev ? `${proto}://${window.location.hostname}:5000` : window.location.origin);
const API = axios.create({ baseURL: `${ORIGIN}/api` });

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('wt_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const CATEGORIES = [
  { id:'love',     label:'Love',     emoji:'❤️',  color:'#FF4E8A' },
  { id:'career',   label:'Career',   emoji:'💼',  color:'#FF8C69' },
  { id:'wealth',   label:'Wealth',   emoji:'💰',  color:'#30D1A7' },
  { id:'flourish', label:'Flourish', emoji:'🌸',  color:'#AF52DE' },
];

export const SECURITY_QUESTIONS = [
  "What is your mother's maiden name?",
  "What was the name of your first pet?",
  "What city were you born in?",
  "What is your favourite childhood movie?",
  "What was your school's name?",
  "What is your oldest sibling's middle name?",
];

export const LEAF_TIERS = [
  { emoji:'🏆', label:'Legendary',   min:400 },
  { emoji:'✨', label:'Radiant',     min:150 },
  { emoji:'🌸', label:'Flourishing', min:60  },
  { emoji:'🌿', label:'Sapling',     min:20  },
  { emoji:'🌱', label:'Seedling',    min:0   },
];
export const getLeafTier = (score = 0) =>
  LEAF_TIERS.find(t => score >= t.min) ?? LEAF_TIERS[LEAF_TIERS.length - 1];

export const getCategoryColor = id => CATEGORIES.find(c=>c.id===id)?.color || '#b0b0d8';
export const getCategoryEmoji = id => CATEGORIES.find(c=>c.id===id)?.emoji || '🙏';
export const getCategoryLabel = id => CATEGORIES.find(c=>c.id===id)?.label || id;
export const dicebear = name => `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(name||'user')}&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf`;
export const photoUrl  = p => p?.startsWith('http') ? p : p ? `${ORIGIN}${p}` : null;
export const API_ORIGIN = ORIGIN;
export const firstName = name => name?.split(' ')[0] || name || '';

export const verifyForChange = (data) => API.post('/users/verify-for-change', data);
export const changeMobile    = (data) => API.post('/users/change-mobile', data);

export const uploadPhoto  = (userId, formData) => API.post(`/users/${userId}/media/photo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deletePhoto  = (userId, index)    => API.delete(`/users/${userId}/media/photo/${index}`);
export const setDefault   = (userId, index)    => API.put(`/users/${userId}/media/default/${index}`);
export const uploadVideo  = (userId, formData) => API.post(`/users/${userId}/media/video`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteVideo  = (userId, index)    => API.delete(`/users/${userId}/media/video/${index}`);

export const fetchReels = (limit = 20, skip = 0) => API.get(`/media/reels?limit=${limit}&skip=${skip}`);

export default API;
